module.exports = __webpack_public_path__ + "img/header_grad.0b174c3c.png";